import dayjs from 'dayjs';

import { CalendarType } from '@enums/index';
import { BlackoutDateResponse } from '@modules/availability/types';
import { SlotWithId } from '@modules/find-mentor/types';

export const checkIsFileGTLimit = (size: number, limit: number) => {
    const isGreaterThanLimit = size / 1024 / 1024 > limit;
    if (isGreaterThanLimit) {
        return true;
    }
    return false;
};

export const getCurrencySymbol = (currencyValue: string) => {
    if (currencyValue === 'INR') {
        return '₹';
    }
    if (currencyValue === 'USD') {
        return '$';
    }
    return currencyValue;
};

export const getFormattedPrice = (price: string | number, currency: string) => {
    const format = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
    });
    return format.format(+price);
};

export const sortByFilterArr = [
    {
        label: 'Name',
        value: 'name',
    },
    {
        label: 'Total Experience',
        value: 'totalExperience',
    },
    {
        label: 'Total Rating',
        value: 'totalRating',
    },
    {
        label: 'Sessions Completed',
        value: 'sessionsCompleted',
    },
];

export const isBlackoutDay = (date: Date, blackouts: BlackoutDateResponse[]) => {
    let isBlackout: boolean = false;
    if (blackouts && blackouts?.length > 0) {
        for (let i = 0; i < blackouts?.length; i += 1) {
            const blackoutDate = new Date(blackouts[i].date).getDate();
            const blackoutMonth = new Date(blackouts[i].date).getMonth();
            const blackoutYear = new Date(blackouts[i].date).getFullYear();
            if (
                blackoutDate === date.getDate() &&
                blackoutMonth === date.getMonth() &&
                blackoutYear === date.getFullYear()
            ) {
                isBlackout = true;
                break;
            }
        }
    }
    return isBlackout;
};

export const getAvailableHoursForCurrentDate = (availabilityForDay: SlotWithId[], date: Date) => {
    const finalAvailableDays = availabilityForDay.map(item => {
        const currDate = dayjs(date).format('YYYY-MM-DD');
        const availStartSlot = item.startTime.split('T')[1];
        const availEndSlot = item.endTime.split('T')[1];
        const finalStartDateString = `${currDate}T${availStartSlot}`;
        const finalEndDateString = `${currDate}T${availEndSlot}`;
        const localItem: SlotWithId = {
            id: item.id,
            startTime: finalStartDateString,
            endTime: finalEndDateString,
        };
        return localItem;
    });
    return finalAvailableDays;
};

export const getUniqueNumber = () => Math.trunc(Math.random() * 10000000);

export const convertToUTC = (datetime: string) =>
    new Date(datetime).toLocaleString('en-US', { timeZone: 'UTC' });

export const getHourFromISOTimeString = (datetime: string) => +datetime.split('T')[1].split(':')[0];

export const getCalendarLinkDateFormat = (datetime: string, calenderType: CalendarType) => {
    let format = '';
    switch (calenderType) {
        case CalendarType.GOOGLE:
            format = 'YYYYMMDDTHHmmss';
            break;
        case CalendarType.YAHOO:
            format = 'YYYYMMDDTHHmmss';
            break;
        case CalendarType.OUTLOOK:
            format = 'YYYY-MM-DDTHH:mm:ss';
            break;
        default:
            break;
    }
    const dateTime = dayjs(datetime).utc().format(format);
    return dateTime;
};

export const replaceHttps = (value: string) =>
    value?.includes('https://') ? value?.replace('https://', '') : value;
